import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { AccessType } from "@quintype/components";

import { TextField } from "../../atoms/textfield";
import { Button } from "../../atoms/button";
import { SUBSCRIPTION_PAGE_URL } from "../../../../isomorphic/constants";
import Loader from "../../atoms/loader";
import { IS_OPEN_LOGIN_FORM, USER_SUBSCRIPTION } from "../../helper/actions";
import IntegrationData from "../../../../../config/integrations.js";
import { isValidEmail } from "../../../utils";
import "./payment-checkout-page.m.css";

const PaymentCheckoutLayout = ({
  initAccessType,
  validateCoupon,
  initRazorPayPayment,
  initStripePayment,
  initPaypalPayment,
  selectedPlan,
  planType,
  redirectURL,
  config,
  navigateTo,
  member,
  manageLoginForm,
  paymentCheckout,
  subscriptionPlans,
  getSubscriptionForUser,
  userSubscriptionDetails,
  userSubscription
}) => {
  const [email, setEmail] = useState();
  const [isLoading, setLoading] = useState(false);
  const [paymentOption, setPaymentOption] = useState({ razorpay: "", paypal: "", stripe: true });
  const [error, setError] = useState("");
  const [useSelectedPlan, setUseSelectedPlan] = useState(selectedPlan);
  const { ga } = global;

  async function handlePaymentSuccess(res, successUrl) {
    ga &&
      ga("send", {
        hitType: "pageview",
        page: "/subscription-success"
      });

    await setLoading(false);
    await setSubscribedUser(res);
    await navigateTo(successUrl);
  }

  useEffect(() => {
    !global.AccessType && initAccessType();
  }, []);

  const onChangeEmail = e => {
    setEmail(e.target.value);
  };

  const handleChange = event => {
    const value = event.target.value;
    setError("");
    if (value === "razorpay") {
      setPaymentOption({ razorpay: event.target.value });
      selectEquivalentOneTimePlan();
    } else if (value === "paypal") {
      setPaymentOption({ paypal: event.target.value });
      selectEquivalentRecurringPlan();
    } else if (value === "stripe") {
      setPaymentOption({ stripe: event.target.value });
      selectEquivalentRecurringPlan();
    }
  };

  const setSubscribedUser = res => {
    const subscriptionData = (res && res.subscription) || [];
    const getUserSubscription = [...userSubscription];

    getUserSubscription.unshift(subscriptionData);
    const hasSub = getUserSubscription
      .filter(subscription => subscription.active === true)
      .filter(item => get(item, ["assets", 0, "type"], "") === "site");
    if (hasSub.length > 0) {
      userSubscriptionDetails({ userHasSubscription: true, userSubscription: getUserSubscription });
    } else {
      userSubscriptionDetails({ userHasSubscription: false, userSubscription: getUserSubscription });
    }
  };

  const payMent = (initRazorPayPayment, initStripePayment, initPaypalPayment) => {
    if (!member) {
      manageLoginForm(true);
      return false;
    }
    if (paymentCheckout === "gift-subscription" && !isValidEmail(email)) {
      setError("Invalid Email");
      return false;
    }

    setLoading(true);

    const appendSuccessURL = `?subscription-status=success` + (planType !== "standard" ? "&sena=true" : "");

    if (paymentOption.razorpay) {
      const selectedPlanObj = Object.assign({}, useSelectedPlan);
      const successUrl = redirectURL + appendSuccessURL;
      const options = {
        argType: "options",
        selectedPlan: selectedPlanObj,
        planType: planType,
        couponCode: "",
        recipientSubscriber: {
          recipient_identity_provider: "email",
          recipient_identity: email
        }
      };
      initRazorPayPayment(options)
        .then(async res => {
          // TODO need to store this invoice responce in store for my account

          await handlePaymentSuccess(res, successUrl);
        })
        .catch(error => {
          setLoading(false);
          const getErrorMessage = get(error, ["error", "message", "subscriber", 0], "");
          if (error.message === "user closed the payment") {
            setError("User closed the payment.");
          } else if (getErrorMessage === "already has active subscription for the same plan") {
            setError(
              `You already have an active recurring subscription. For support in addition to your current subscription, you can check out and join NL Sena or gift a subscription to someone you know`
            );
          } else "Oops! Something went wrong";
        });
      return true;
    }
    if (paymentOption.stripe) {
      const host = get(config, ["publisher", "frontend_url"], "");
      const selectedPlanObj = Object.assign({}, useSelectedPlan);
      const successUrl = host + redirectURL + appendSuccessURL;
      const cancelUrl = host + "/payment-checkout";
      const options = {
        argType: "options",
        selectedPlan: selectedPlanObj,
        planType: planType,
        couponCode: "",
        successUrl,
        cancelUrl,
        recipientSubscriber: {
          recipient_identity_provider: "email",
          recipient_identity: email
        }
      };
      initStripePayment(options)
        .then(async res => {
          await handlePaymentSuccess(res, redirectURL);
        })
        .catch(error => {
          setLoading(false);
          const getErrorMessage = get(error, ["error", "message", "subscriber", 0], "");
          if (error.message === "user closed the payment") {
            setError("User closed the payment.");
          } else if (getErrorMessage === "already has active subscription for the same plan") {
            setError(
              `You already have an active recurring subscription. For support in addition to your current subscription, you can check out and join NL Sena or gift a subscription to someone you know`
            );
          } else "Oops! Something went wrong";
        });
      return true;
    }
    if (paymentOption.paypal) {
      const splitDescription = (useSelectedPlan.description && useSelectedPlan.description.split(",")) || "";
      if (!splitDescription[1]) {
        console.error("USD plan id missing in recurring plan");
        return;
      }

      const usdPlan = subscriptionPlans.find(plan => plan.id == splitDescription[1]);
      if (!usdPlan) {
        console.error(`Equivalent USD plan with id ${splitDescription[1]} not found`);
        return;
      }

      const selectedPlanObj = Object.assign({}, usdPlan);

      const host = get(config, ["publisher", "frontend_url"], "");
      const returnUrl = host + redirectURL + appendSuccessURL;
      const cancelUrl = host + "/payment-checkout";
      const options = {
        argType: "options",
        selectedPlan: selectedPlanObj,
        planType: planType,
        couponCode: "",
        recipientSubscriber: {
          recipient_identity_provider: "email",
          recipient_identity: email
        },
        returnUrl,
        cancelUrl
      };
      initPaypalPayment(options)
        .then(async res => {
          await handlePaymentSuccess(res, redirectURL);
        })
        .catch(error => {
          setLoading(false);
          const getErrorMessage = get(error, ["error", "message", "subscriber", 0], "");
          if (error.message === "user closed the payment") {
            setError("User closed the payment.");
          } else if (getErrorMessage === "already has active subscription for the same plan") {
            setError(
              `You already have an active recurring subscription. For support in addition to your current subscription, you can check out and join NL Sena or gift a subscription to someone you know`
            );
          } else "Oops! Something went wrong";
        });
      return true;
    }
    setLoading(false);
    setError("Please select one payment options");
    return false;
  };

  const selectEquivalentOneTimePlan = () => {
    if (planType === "standard") {
      const splitDescription = (selectedPlan.description && selectedPlan.description.split(",")) || "";
      const getSelectedPlan = subscriptionPlans.filter(plan => plan.id == splitDescription[0]);
      setUseSelectedPlan(getSelectedPlan[0]);
    }
  };

  const selectEquivalentRecurringPlan = () => {
    if (planType === "standard") {
      setUseSelectedPlan(selectedPlan);
    }
  };

  return (
    <div styleName="inner-wrapper">
      <h1 styleName="headline">Confirm details</h1>
      {useSelectedPlan.title && (
        <div styleName="name-wrapper">
          <span styleName="text">{planType === "standard" ? "Subscription Type:" : "Project Name:"} </span>
          <span styleName="text plan-name">{useSelectedPlan.title}</span>
        </div>
      )}
      {useSelectedPlan.price_cents && (
        <div styleName="name-wrapper">
          <span styleName="text"> {planType === "standard" ? "Billing:" : "Contribution:"} </span>
          <span styleName="text plan-name">
            {useSelectedPlan.price_cents / 100}{" "}
            {/* {planType === "standard" && checkboxSelect
              ? "every " + useSelectedPlan.duration_length + " " + useSelectedPlan.duration_unit
              : null} */}
          </span>
        </div>
      )}
      {planType === "standard" && paymentCheckout === "gift-subscription" && (
        <div styleName="email-wrapper">
          <TextField
            type="email"
            value={email}
            onChange={onChangeEmail}
            placeholder="Email Address Of Giftee"
            required
          />
        </div>
      )}

      <div styleName="text plan-name price-wrapper">
        <span>To pay</span>
        <span styleName="price"> &#x20B9; {useSelectedPlan.price_cents / 100}</span>
      </div>
      <h3 style={{ fontWeight: "bold", margin: "2rem 0", fontFamily: "var(--primary-font)" }}>Payment Method</h3>
      <div styleName="payment-selection">
        {useSelectedPlan.supported_payment_providers
          .sort()
          .reverse()
          .map(item => {
            if (item === "razorpay") {
              return (
                <div styleName="payment-wrapper" key={item}>
                  <div styleName="radio text">
                    <input
                      checked={paymentOption[item]}
                      name="payment"
                      onChange={handleChange}
                      id={item}
                      type="radio"
                      value={item}
                    />
                    <label htmlFor={item} styleName="radio-label">
                      <div styleName="label-inner-wrapper">
                        <div styleName="label-text">Netbanking, UPI, Wallets or RuPay Card</div>
                        <div styleName="label-img-wrapper">
                          <img
                            alt="google pay"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/1b086995-83ca-4388-b0ad-88383e02c2da/googlepay.png"
                          />
                          <img
                            alt="amazon pay"
                            style={{ height: "1.2rem" }}
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/ee98c60b-d1e3-4626-aa4d-fdc7bb2181fa/amazonpay.png"
                          />
                          <img
                            alt="phone pe"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/f104aa32-abb5-48d3-84ea-34b7cfcbf20f/phonepe.png"
                          />
                          <img
                            alt="RuPay"
                            style={{ height: "2.4rem" }}
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/2e01405e-03c2-4ce4-818c-99461a20c0e0/Rupay_Logo.png"
                          />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              );
            } else if (item === "paypal" && planType === "standard") {
              return (
                <div styleName="payment-wrapper" key={item}>
                  <div styleName="radio text">
                    <input
                      checked={paymentOption[item]}
                      name="payment"
                      onChange={handleChange}
                      id={item}
                      type="radio"
                      value={item}
                    />
                    <label htmlFor={item} styleName="radio-label">
                      <div styleName="label-inner-wrapper">
                        <div styleName="label-text">PayPal</div>
                        <div styleName="label-img-wrapper">
                          <img
                            style={{ height: "1.5rem" }}
                            alt="paypal"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/8c48530f-1c8a-4729-94aa-d8a0312cbec6/paypal.png"
                          />
                        </div>
                      </div>
                    </label>
                  </div>
                  {paymentOption[item] && (
                    <div styleName="payment-note">
                      <small>
                        Only for subscribers based outside India. You will be charged in USD. You can turn off the
                        auto-renewal from the subscriber dashboard anytime.
                      </small>
                    </div>
                  )}
                </div>
              );
            } else if (item === "stripe") {
              return (
                <div styleName="payment-wrapper" key={item}>
                  <div styleName="radio text">
                    <input
                      checked={paymentOption[item]}
                      name="payment"
                      onChange={handleChange}
                      id={item}
                      type="radio"
                      value={item}
                    />
                    <label htmlFor={item} styleName="radio-label">
                      <div styleName="label-inner-wrapper">
                        <div styleName="label-text">Credit or Debit Card </div>
                        <div styleName="label-img-wrapper">
                          <img
                            alt="master card"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/252dd4b3-d916-4407-ae66-b76f70d78df1/mastercard.png"
                          />
                          <img
                            styleName="radio-label-img"
                            alt="visa card"
                            src="https://images.assettype.com/newslaundry/2020-10/b62f6c9f-ba78-480d-909f-206414bb57b0/visacard.png"
                          />
                          <img
                            alt="maestro card"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/8bb15b8a-02d1-4654-98b0-a5dda9b4af47/maestrp.png"
                          />
                          <img
                            alt="americanexpress card"
                            styleName="radio-label-img"
                            src="https://images.assettype.com/newslaundry/2020-10/955142d7-7686-4268-97f1-4c5329c2b6ad/americanexpresscard.png"
                          />
                        </div>
                      </div>
                    </label>
                  </div>
                  {paymentOption[item] && planType === "standard" ? (
                    <div styleName="payment-note">
                      <small>
                        Your subscription will be renewed automatically, if your bank supports it. You can turn off the
                        auto-renewal from the subscriber dashboard anytime.
                      </small>
                    </div>
                  ) : null}
                </div>
              );
            }
          })}
      </div>

      {error && <div styleName="error">{error}</div>}
      <div onClick={() => payMent(initRazorPayPayment, initStripePayment, initPaypalPayment)} styleName="button">
        <Button className="nl-btn-large" disabled={isLoading}>
          {isLoading ? <Loader /> : "SUBSCRIBE"}
        </Button>
      </div>
    </div>
  );
};

PaymentCheckoutLayout.propTypes = {
  config: PropTypes.object,
  selectedPlan: PropTypes.object,
  navigateTo: PropTypes.func,
  manageLoginForm: PropTypes.func,
  member: PropTypes.object,
  initAccessType: PropTypes.func,
  initRazorPayPayment: PropTypes.func,
  initStripePayment: PropTypes.func,
  initPaypalPayment: PropTypes.func,
  validateCoupon: PropTypes.func,
  paymentCheckout: PropTypes.string,
  redirectURL: PropTypes.string,
  planType: PropTypes.string,
  getSubscriptionForUser: PropTypes.func,
  userSubscriptionDetails: PropTypes.func
};

const PaymentCheckoutPageBase = ({
  selectedPlan,
  planType,
  redirectURL,
  config,
  navigateTo,
  member,
  manageLoginForm,
  paymentCheckout,
  subscriptionPlans,
  userSubscriptionDetails,
  userSubscription
}) => {
  if (Object.keys(selectedPlan).length < 1) {
    return (
      <div styleName="select-paln">
        <h1>Please select the option...</h1>
        <div styleName="go-back">
          <Button socialButton href={SUBSCRIPTION_PAGE_URL}>
            SUBSCRIBE
          </Button>
        </div>
      </div>
    );
  }

  const integrationsConfig = IntegrationData();
  const email = get(member, ["email"], "");
  const phone = get(member, ["metadata", "phone"], "");
  const isStaging = get(config, ["publisher", "publisher", "accessTypeEnvironment"], true);
  const enableAccesstype = get(config, ["publisher", "publisher", "enableAccesstype"], true);
  const accessTypeKey = isStaging ? integrationsConfig.stagingAccessTypeKey : integrationsConfig.accessTypeKey;
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;
  return (
    <div className="full-width-with-padding" styleName="wrapper">
      <AccessType
        enableAccesstype={enableAccesstype}
        isAccessTypeCampaignEnabled={true}
        isStaging={isStaging}
        accessTypeKey={accessTypeKey}
        email={email}
        phone={phone}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
      >
        {({
          initAccessType,
          validateCoupon,
          initRazorPayPayment,
          initStripePayment,
          initPaypalPayment,
          getSubscriptionForUser
        }) => {
          return (
            <PaymentCheckoutLayout
              initAccessType={initAccessType}
              validateCoupon={validateCoupon}
              initRazorPayPayment={initRazorPayPayment}
              initStripePayment={initStripePayment}
              initPaypalPayment={initPaypalPayment}
              selectedPlan={selectedPlan}
              planType={planType}
              redirectURL={redirectURL}
              config={config}
              navigateTo={navigateTo}
              member={member}
              manageLoginForm={manageLoginForm}
              paymentCheckout={paymentCheckout}
              subscriptionPlans={subscriptionPlans}
              getSubscriptionForUser={getSubscriptionForUser}
              userSubscriptionDetails={userSubscriptionDetails}
              userSubscription={userSubscription}
            />
          );
        }}
      </AccessType>
    </div>
  );
};

PaymentCheckoutPageBase.propTypes = {
  config: PropTypes.object,
  selectedPlan: PropTypes.object,
  navigateTo: PropTypes.func,
  manageLoginForm: PropTypes.func,
  member: PropTypes.object,
  paymentCheckout: PropTypes.string,
  redirectURL: PropTypes.string,
  planType: PropTypes.string,
  userSubscriptionDetails: PropTypes.func
};
const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  },
  navigateTo: url => global.app.navigateToPage(dispatch, url),
  userSubscriptionDetails: function(payload) {
    dispatch({
      type: USER_SUBSCRIPTION,
      payload: payload
    });
  }
});

const mapStateToProps = state => {
  return {
    selectedPlan: get(state, ["selectedPlan", "plan"], {}),
    planType: get(state, ["selectedPlan", "planType"], ""),
    subscriptionPlans: get(state, ["selectedPlan", "subscriptionPlans"], []),
    redirectURL: get(state, ["selectedPlan", "redirectUrl"], ""),
    config: get(state, ["qt", "config"], {}),
    member: get(state, ["member"], null),
    paymentCheckout: get(state, ["paymentCheckout"], ""),
    userSubscription: get(state, ["isSubscribedUser", "userSubscription"], [])
  };
};

export const PaymentCheckoutPage = connect(mapStateToProps, mapDispatchToProps)(PaymentCheckoutPageBase);
